import * as _ from "lodash";
import {TaskRelationModel} from "../models/task-relation.model";
import {RelationType} from "../../commons/types/relation.type";
import {TaskPurposeType} from "../../commons/types/task-purpose.type";

export const BLOCKED_RELATION_TYPES = [RelationType.BlockedBy, RelationType.Blocking];

export function flattenTaskRelations(taskList: any[]): TaskRelationModel[] {
  return _.flatMap(taskList, task => task?.relations || []);
}

export function isBlockedRelationType(type: RelationType): boolean {
  return BLOCKED_RELATION_TYPES.includes(type);
}

export function dedupeRelationsByService(relations: TaskRelationModel[], preferredPurpose?: TaskPurposeType): TaskRelationModel[] {
  const groups = _.groupBy(relations, relation => relation.details?.serviceId
    ? `${relation.type}::service::${relation.details.serviceId}`
    : `${relation.type}::task::${relation.relatedTaskId}`);
  return Object.values(groups).map(group =>
    group.find(relation => !!preferredPurpose && relation.details?.taskPurpose === preferredPurpose) || group[0]
  );
}
